const dashboardData = {
    user: {
        id: "user-demo",
        created: new Date("2022-08-12"),
        email: "coach@eastview.edu",
        enabled: true,
        lastLogin: new Date(),
        name: "David Coach",
        subscriptionEnds: new Date("2027-06-30"),
        version: { android: 455, ios: 128, web: 1 },
    },
    teams: [
        {
            id: "team-eastview",
            gender: "male",
            level: "school",
            location: {
                city: "Islip",
                country: "United States",
                county: "Suffolk",
                postalCode: "11751",
                state: "NY",
            },
            managers: ["manager-1", "manager-2"],
            name: "Eastview Track & Field",
            owner: { id: "user-demo", name: "David Coach", email: "coach@eastview.edu" },
            public: true,
            unit: "imperial",
            slug: "eastview-track",
            seasons: {
                "season-2026-outdoor": { id: "season-2026-outdoor", name: "outdoor", year: 2026, type: "outdoor-track" },
                "season-2026-indoor": { id: "season-2026-indoor", name: "indoor", year: 2026, type: "indoor-track" },
            },
        },
    ],
    stats: { athletes: 48, upcomingMeets: 4, seasonBests: 126, teamRecords: 8 },
    meets: [
        {
            id: "meet-1",
            name: "Suffolk County Classic",
            date: new Date("2026-07-02T15:30:00"),
            location: "West Islip High School",
            type: "Invitational",
            entries: 34,
        },
        {
            id: "meet-2",
            name: "Eastview vs. Central",
            date: new Date("2026-07-08T16:00:00"),
            location: "Eastview Track",
            type: "Dual Meet",
            entries: 42,
        },
        {
            id: "meet-3",
            name: "League Championships",
            date: new Date("2026-07-16T14:00:00"),
            location: "Connetquot High School",
            type: "Championship",
            entries: 28,
        },
    ],
};
export const mockTeamRepository = {
    async getDashboard() {
        return dashboardData;
    },
};
